import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ShieldCheck, CheckCircle2, AlertTriangle, X } from "lucide-react";

// Per-representation reps/certs checklist chip for the in-bid Anvil cockpit. Auto-answered reps come from
// WD's VERIFIED profile model; ⚠ items need human confirmation before signing (never machine-guessed).
export function RepsCertsChip({ dealId }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let alive = true;
    api.get(`/bids/${dealId}/reps-certs`).then((r) => { if (alive) setData(r.data); }).catch(() => {});
    return () => { alive = false; };
  }, [dealId]);
  if (!data || !data.applicable) return null;
  return (
    <div className="relative">
      <button data-testid="reps-certs-chip" onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 text-[11px] bg-white/10 text-zinc-200 px-2.5 py-1.5 rounded-md hover:bg-white/20">
        <ShieldCheck className="h-3.5 w-3.5 text-gold" /> Reps/Certs
        <span className="text-emerald-300 font-semibold" data-testid="reps-certs-answered">{data.answered}✓</span>
        {data.to_confirm > 0 && <span className="text-amber-300 font-semibold" data-testid="reps-certs-toconfirm">{data.to_confirm}⚠</span>}
      </button>
      {open && (
        <div data-testid="reps-certs-panel"
          className="absolute right-0 mt-2 w-80 max-h-[60vh] overflow-auto bg-white text-zinc-900 rounded-lg shadow-xl border border-zinc-200 z-50 p-3">
          <div className="flex items-center justify-between mb-2">
            <div className="text-xs font-semibold">Reps &amp; Certs — per-representation status</div>
            <button onClick={() => setOpen(false)} data-testid="reps-certs-close"><X className="h-3.5 w-3.5 text-zinc-500" /></button>
          </div>
          <div className="space-y-1.5">
            {data.items.map((it, i) => (
              <div key={i} className="flex items-start gap-2 text-[11px]" data-testid={`reps-certs-item-${i}`}>
                {it.status === "answered"
                  ? <CheckCircle2 className="h-3.5 w-3.5 text-emerald-600 shrink-0 mt-0.5" />
                  : <AlertTriangle className="h-3.5 w-3.5 text-amber-600 shrink-0 mt-0.5" />}
                <div>
                  <div className="font-medium text-zinc-800">{it.label} <span className="text-zinc-400">· {it.group}</span></div>
                  <div className={it.status === "answered" ? "text-emerald-700" : "text-amber-700"}>{it.answer}</div>
                </div>
              </div>
            ))}
          </div>
          <p className="mt-2 text-[10px] text-zinc-400">Auto-answered from WD's verified profile; ⚠ items need human confirmation before signing (never machine-guessed).</p>
        </div>
      )}
    </div>
  );
}
